import { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  Grid, Box, Table, TableRow, TableCell, TableBody,
  IconButton,  Tooltip as MaterialUITooltip, 
  TextField,
  Paper,
  Select,
  MenuItem,
  Drawer
} from "@material-ui/core";
import {  Edit, Info } from '@material-ui/icons';
import { Button} from "@material-ui/core";
import Loader from "react-spinners/ClipLoader";
import { REACT_APP_APIM_URL} from "../../utilities/GlobalConstants";
import store from "../..";
import "../../assets/styles/_notification-configuration.scss";
import { RootState } from "../../reducers/rootReducer";
import { RouteComponentProps } from "react-router-dom";
import { setNotificationConfiguration } from "../../slices/notificationConfigurationSlice";
import { convertDateTimeBasedOnConfigPostgre, getToken } from "../../utilities/helperFunctions";
import { AuthContextProps, withAuth } from "react-oidc-context";
import React from "react";
import { setTemperatureUpdatedBy, setTemperatureUpdatedOn, setConfigurationUpdatedBy,setConfigurationUpdatedOn } from "../../slices/changeHistorySlice";
import { loadConfigPlants } from "../../slices/configurationSlice";
import { getPlantReferences } from "../../configuration";
import HistoryTable from "../common/HistoryTable";
import { GridCloseIcon } from "@mui/x-data-grid";
export const NOTIFICATION_CONFIGURATION_ID = "_NOTIFICATION_CNFIGURATION";

interface INotificationConfigurationProps extends RouteComponentProps{ }

interface OIDCAuth {
  auth?: AuthContextProps
}

const mapStateToProps = (state: RootState) => {
  return {
    notificationConfiguration : state.notificationConfigurationState.notificationConfiguration,
    accessibleFeatures: state.features.accessibleFeatures,
    userRoles: state.adminPanel.currentUserRoleState,
    userRolesIsEditable: state.adminPanel.isEditable,
    changeHistory: state.changeHistoryState,
    plants: state.configuration.plants,
    currentPlantId : state.scenarioSimulator.currentPlantId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setNotificationConfiguration: (notificationConfiguration: any[]) => dispatch(setNotificationConfiguration(notificationConfiguration)),
    setTemperatureUpdatedBy: (updatedBy: string) => dispatch(setTemperatureUpdatedBy(updatedBy)),
    setTemperatureUpdatedOn: (updatedOn: string) => dispatch(setTemperatureUpdatedOn(updatedOn)),
    setConfigurationUpdatedBy: (updatedBy: string) => dispatch(setConfigurationUpdatedBy(updatedBy)),
    setConfigurationUpdatedOn: (updatedOn: string) => dispatch(setConfigurationUpdatedOn(updatedOn)),
    loadConfigPlants: (config_plants: []) => dispatch(loadConfigPlants(config_plants))
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type INotificationconfigurationReduxProps = PropsFromRedux & INotificationConfigurationProps & OIDCAuth;

type INotificationConfigurationState = {
  notificationFurnacemodes: String[],
  notificationConfigurationData: [],
  multiCameraLoader: boolean,
  submitButton:boolean,
  showEditTemp:boolean,
  loading: boolean,
  updatedMinTemp: number,
  updatedMaxTemp: number,
  updatedNotificationConfigurationData : [],
  globalMinTemp: number,
  globalMaxTemp: number,
  isDrawerVisible: boolean,
  initialNotificationConfigurationData:[],
}



class NotificationConfiguration extends Component<INotificationconfigurationReduxProps, INotificationConfigurationState>{

  constructor(props) {
    super(props);

    this.state = {
      notificationFurnacemodes : [],
      notificationConfigurationData : [],
      multiCameraLoader: false,
      submitButton: false,
      showEditTemp: false,
      loading: false,
      updatedMinTemp: 0,
      updatedMaxTemp: 0,
      updatedNotificationConfigurationData: [],
      globalMinTemp: 0,
      globalMaxTemp: 0,
      isDrawerVisible: false,
      initialNotificationConfigurationData:[],
    }
  }

  componentDidMount() {
    let plant : any = getPlantReferences();
    let currentPlant = plant.filter(item => item.id === this.props.currentPlantId)
    plant = currentPlant[0]
    this.setState({
      globalMinTemp: Number(plant.ti_temp_min),
      globalMaxTemp: Number(plant.ti_temp_max),
      updatedMinTemp: Number(plant.ti_temp_min),
      updatedMaxTemp: Number(plant.ti_temp_max)
    });
    if(this.props.notificationConfiguration.length <= 0)
    {
        this.getNotificationConfiguration()
    }
    else
    {
        let resp = this.props.notificationConfiguration
        let colNames : any[] = []
        Object.keys(resp[0]).map((key,i) => {
          Object.keys(resp[0][key]).map((key1,j) => {
            if(key1 !== "rule_desc" && !colNames.includes(key1)){
              colNames.push(key1)
            }
          })
        })
        let index = colNames.indexOf("severity");
        let x = colNames.splice(index, 1);
        colNames.unshift("severity");
        
        this.setUpdatedNotificationConfigurationData()
        this.setState({
          notificationConfigurationData: resp[0],
          notificationFurnacemodes: colNames,
          multiCameraLoader: false,
          initialNotificationConfigurationData: resp[0]
        })
    }
  };

  componentDidUpdate(prevProps) {
  }

  setUpdatedNotificationConfigurationData =() =>{
    let resp = this.props.notificationConfiguration
    let updateObject :any = {}
        Object.keys(resp[0]).map((key,i) => {
          let objkey = key
          updateObject[objkey] = {};
        })
    this.setState({
      updatedNotificationConfigurationData: updateObject
    })
  }

  getNotificationConfiguration = () => {
    this.setState({ multiCameraLoader: true });
    getToken(this.props.auth).then((accessToken)=>{
      fetch(`${REACT_APP_APIM_URL}/thermalimage/getNotificationConfiguration`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*"
        },
      })
        .then((res) => res.json())
        .then(
          (resp) => {
            this.props.setNotificationConfiguration(resp)
            let colNames : any[] = []
            Object.keys(resp[0]).map((key,i) => {
              Object.keys(resp[0][key]).map((key1,j) => {
                if(key1 !== "rule_desc" && !colNames.includes(key1)){
                  colNames.push(key1)
                }
              })
            })
            
            let index = colNames.indexOf("severity");
            let x = colNames.splice(index, 1);
            colNames.unshift("severity");
            this.setState({
              notificationConfigurationData: resp[0],
              notificationFurnacemodes: colNames,
              multiCameraLoader: false,
              initialNotificationConfigurationData: resp[0]
            })
          },
          (error) => {
            this.setState({ multiCameraLoader: false })
            console.log("error", error)
          }
        )
    })
  }

  getInputValue(e,key, mode){
    let currentObj:any = this.state.notificationConfigurationData
    let newObj:any = this.state.updatedNotificationConfigurationData
    currentObj = JSON.parse(JSON.stringify(currentObj));
    currentObj[key][mode] = e.target.value
    newObj[key][mode] = e.target.value    
    this.setState({
      notificationConfigurationData: currentObj,
      updatedNotificationConfigurationData: newObj
    })
  }

  updateConfiguration = () => {
    this.setState({loading:true})
    getToken(this.props.auth).then((accessToken)=>{
      const tempJson = {
        updatedNotificationConfigurationData: this.state.updatedNotificationConfigurationData,
        userId: this.props.userRoles.userId
      };
      fetch(`${REACT_APP_APIM_URL}/thermalimage/updateConfigurationData`, {
          method: "POST",
          headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
          },
          body: JSON.stringify(tempJson),
        })
          .then((res) => res.json())
          .then(
              (data) => {
                  let respArr:any = []
                  respArr.push(data[0])
                  this.props.setNotificationConfiguration(respArr)
                  this.props.setConfigurationUpdatedBy(data[1]['updated_by'])
                  this.props.setConfigurationUpdatedOn(data[1]['updated_on'])
                  this.setUpdatedNotificationConfigurationData()
                  this.setState({loading:false})
                  this.getNotificationConfiguration()
              },
              (error) => {
                  console.log("error", error)
                  this.setState({loading:false})
              }
          )
        this.setState({submitButton : false})
    });
  }

  updateMinMaxTemp = () => {
    getToken(this.props.auth).then((accessToken)=>{
      const tempJson = {
        ti_temp_min: this.state.updatedMinTemp,
        ti_temp_max: this.state.updatedMaxTemp,
        plantID: this.props.currentPlantId,
        userId: this.props.userRoles.userId
      };
      fetch(`${REACT_APP_APIM_URL}/thermalimage/updateTIMinMaxTemp`, {
          method: "POST",
          headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
          },
          body: JSON.stringify(tempJson),
        })
          .then((res) => res.json())
          .then(
              (data) => {
                  this.setState(
                    {
                      showEditTemp : false
                    }
                  )
                  
                  let plants = JSON.parse(JSON.stringify(getPlantReferences()));
                  let currentPlant = plants.filter(item => item.id === this.props.currentPlantId)
                  plants = currentPlant[0]
                  plants.ti_temp_max = this.state.updatedMaxTemp
                  plants.ti_temp_min = this.state.updatedMinTemp
                  let updatedPlant : any = []
                  updatedPlant.push(plants)
                  this.props.loadConfigPlants(updatedPlant)
                  this.setState({
                    globalMinTemp: this.state.updatedMinTemp,
                    globalMaxTemp: this.state.updatedMaxTemp,
                    updatedMinTemp: this.state.updatedMinTemp,
                    updatedMaxTemp: this.state.updatedMaxTemp
                  });
                  this.props.setTemperatureUpdatedBy(data['updated_by'])
                  this.props.setTemperatureUpdatedOn(data['updated_on'])
              },
              (error) => {
                  console.log("error", error)
              }
          )
    });
  }

  toggleHistoryTableDrawer = () => {
    if(this.state.isDrawerVisible) {
      this.setState({isDrawerVisible: false})
    } else  {
      this.setState({isDrawerVisible : true})
    }
  };

  isConfigurationEditable = () => {
    return this.props.accessibleFeatures.includes("EDITABLE_CONFIGURATION")  && this.props.userRolesIsEditable === true 
  }

  restoreInitialState = () => {
    this.setState({
      notificationConfigurationData: this.state.initialNotificationConfigurationData,
      submitButton: false
    });
  }

  render() {
    return (
      <React.Fragment>
        <div>
        {/* {this.isConfigurationEditable() && */}
          <Paper elevation={3} className='configuration-edit-panel'>
            <div className="editTempBtn" >
              <b>{this.isConfigurationEditable() ? 'Edit Temperature' : 'Temperature'}</b> 
              {this.isConfigurationEditable() && this.state.showEditTemp === false &&
                <Edit style={{ marginLeft: "10px", cursor: 'pointer'}} onClick={(e) => this.setState({showEditTemp : true})}/>
              }
            </div>
            <div className='edit-panel'>
                <Grid>
                  <div className="devaition-legend-holder-configuration">
                    <div className='configuration_color_box_gallery'>
                    </div>
                    <span className='configuration-color-box-galleryMinTempValue'>{this.state.globalMinTemp}</span>
                    <span className='configuration-color-box-galleryMaxTempValue'>{this.state.globalMaxTemp}</span>
                  </div>
                </Grid>
                {/* <div className='editTempPanelBtn'>
                  <Edit onClick={(e) => this.setState({showEditTemp : true})}/> */}
                  {/* <Button variant="outlined" startIcon={<Edit />} onClick={(e) => this.setState({showEditTemp : true})}></Button> */}
                {/* </div> */}
                {this.isConfigurationEditable() && this.state.showEditTemp === true &&
                    <>
                    <TextField className={`minTempField editTextField ${this.state.updatedMinTemp > this.state.updatedMaxTemp ? 'error' : ''}`} id="minTemp" label="Min Temp" value={this.state.updatedMinTemp} onChange={(e) => this.setState({ updatedMinTemp: Number(e.target.value) })} error={this.state.updatedMinTemp > this.state.updatedMaxTemp} helperText={this.state.updatedMinTemp > this.state.updatedMaxTemp ? "Min Temp value cannot be greater than Max Temp value" : ""}/>
                    <TextField className='maxTempField editTextField' id="maxTemp" label="Max Temp" value={this.state.updatedMaxTemp} onChange={(e) => this.setState({ updatedMaxTemp: Number(e.target.value) })} />
                    <div className='editPanelBtn'>
                      <Button className="customBtn" variant="outlined" disabled={this.state.updatedMinTemp <= 0 || this.state.updatedMaxTemp <= 0 || this.state.updatedMinTemp > this.state.updatedMaxTemp} onClick={this.updateMinMaxTemp}> 
                        Update
                      </Button>
                      <Button className="customBtn" variant="outlined" onClick={(e) => this.setState({showEditTemp : false})}>
                        Cancel
                      </Button>
                    </div>
                    </>
                }
                {this.isConfigurationEditable() &&
                    <Grid>
                        <div className="last-updated-holder">
                            <p><span className="lastUpdated">Last Updated By : </span><b>{this.props.changeHistory.temp_updated_by}</b></p>
                            <p><span className="lastUpdated">Last Updated On : </span><b>{convertDateTimeBasedOnConfigPostgre(this.props.changeHistory.temp_updated_on)}</b></p>
                        </div>
                    </Grid>
                }
            </div>
          </Paper>
      {/* } */}
  
        <Paper className="configuration-table-holder">
            <div className="configuration-table-title">
              <b>Threshold for Rules</b>
              {this.isConfigurationEditable() &&
                  <>
                  {this.state.loading == false ?
                  <>
                  {this.state.submitButton === false ?
                      <Edit  style={{ marginLeft: "10px", cursor: 'pointer'}}  onClick={(e) => this.setState(prevState => ({submitButton : !prevState.submitButton}))}/>
                      // <Button variant="outlined" startIcon={<Edit />} onClick={(e) => this.setState(prevState => ({submitButton : !prevState.submitButton}))}>
                      //     Edit
                      // </Button>
                      :
                      <>
                      <Button className="customBtn" style={{ marginLeft: "10px"}} variant="outlined" onClick={this.updateConfiguration}>
                          Update
                      </Button>
                      <Button className="customBtn" style={{ marginLeft: "10px"}} variant="outlined" 
                      onClick={this.restoreInitialState}
                      >
                          Cancel
                      </Button>
                    
                    </>
                  }
                    <MaterialUITooltip className='materialUITooltip' title = {<span className='TooltipTitle'>View history logs</span>}>
                          <IconButton onClick={this.toggleHistoryTableDrawer} style={{float:'right', marginLeft: '10px'  }}>
                            <Info/>
                          </IconButton>
                          </MaterialUITooltip>
                      <Grid>
                          <div className="last-updated-holder-for-configuration">
                          <p><span className="lastUpdated">Last Updated By : </span><b>{this.props.changeHistory.conf_updated_by}</b></p>
                          <p><span className="lastUpdated">Last Updated On : </span><b>{convertDateTimeBasedOnConfigPostgre(this.props.changeHistory.conf_updated_on)}</b></p>
                          </div>
                      </Grid>
                  </>
                  :
                  <div className="loader-grid">
                      <Loader />
                      <p> Updating...</p>
                  </div>
                  }
                  </>
              }
            </div>
            {this.state.multiCameraLoader ? 
                <div className="loader-grid-parent">
                < div className="loader-grid">
                  <Loader />
                  <p> Loading...</p>
                </div>
              </div>
             :
             <Grid container>
             <div className="notification-configuration-table-holder">
               <Table className="notification-configuration-table">
                 <TableBody>
                   <TableRow className="">
                       <TableCell className="table-labels" align="center">Rules</TableCell>
                       {this.state.notificationFurnacemodes.map((mode) => {
                         return <TableCell className="table-labels" align="center" >{mode == 'severity' ? 'Severity' : mode} </TableCell>
                       })}
                   </TableRow>
                   {Object.keys(this.state.notificationConfigurationData).map((key,i) => {
                   return <TableRow className="notification-table-row">
                       <TableCell className="rule-name" align="center" >{key} &nbsp; 
                          <MaterialUITooltip className='materialUITooltip' title={<span className='TooltipTitle'>{this.state.notificationConfigurationData[key]['rule_desc']}</span>}>
                        <IconButton>
                            <Info />
                        </IconButton>
                    </MaterialUITooltip>
                       
                   </TableCell>
                       <TableCell className="" align="center" >
                           {this.state.submitButton === true ?
                             <Select autoWidth className="readonly-text severity-select" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[0]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[0])} style={{ width: "100%" }}>
                                   <MenuItem key={`severity-high`} data-coilgroupid="High" value="High">
                                       High
                                   </MenuItem>
                                   <MenuItem key={`severity-medium`} data-coilgroupid="Medium" value="Medium">
                                       Medium
                                   </MenuItem>
                             </Select>
                             :
                             <input className="readonly-text editableBox form-control" type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[0]]} disabled/>
                           }
                       </TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[1]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[1])} disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[2]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[2])} disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[3]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[3])} disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[4]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[4])} disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[5]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[5])} disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[6]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[6])} disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[7]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[7])} disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[8]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[8])}  disabled={this.state.submitButton === false ? true : false}/></TableCell>
                       <TableCell className="" align="center" ><input className={this.state.submitButton === false ? "readonly-text editableBox form-control" : "readonly-text form-control form-control-readonly"} type="text" value={this.state.notificationConfigurationData[key][this.state.notificationFurnacemodes[9]]} onChange={(e) => this.getInputValue(e, key, this.state.notificationFurnacemodes[9])}  disabled={this.state.submitButton === false ? true : false}/></TableCell>
                   </TableRow>
                   })}
                 </TableBody>
               </Table>
             </div>
           </Grid> 
             }
           
        </Paper>
      </div>
      {this.state.isDrawerVisible &&
          <Drawer 
            anchor="right" 
            open = {this.state.isDrawerVisible} 
            onClose={this.toggleHistoryTableDrawer}
            PaperProps={{ style: { width: 800, padding: 16 } }}
          >
          <Box sx={{ justifyContent: 'space-between', display: 'flex' }}>
            <Box component="b" sx={{mt: 2}}>History Table</Box>
              <Box>
                <IconButton onClick={this.toggleHistoryTableDrawer}>
                <GridCloseIcon />
                </IconButton>
             </Box>
          </Box>
           <HistoryTable />
          </Drawer>
      }
      </React.Fragment>
    );
  }
}

export default withAuth(connector(NotificationConfiguration));
